import memoizeOne from 'memoize-one';
import type { Hotspot, SceneConfigLayers } from '@types';

const getUnusedSet = memoizeOne(
  (hotspotList: Hotspot[], layerList: Required<SceneConfigLayers>['list']) => {
    const set = new Set(hotspotList.map((x) => x.id));
    layerList.forEach(({ hotspotIds = [] }) => {
      hotspotIds.forEach((id) => {
        set.delete(id);
      });
    });
    return set;
  }
);

export function getLayerHotspots({
  fov,
  hotspotList,
  layerList,
}: {
  fov: number;
  hotspotList: Hotspot[];
  layerList: Required<SceneConfigLayers>['list'];
}) {
  const set = new Set(getUnusedSet(hotspotList, layerList));
  layerList
    .filter(({ fovMin, fovMax }) => fov >= fovMin && fov <= fovMax)
    .forEach(({ hotspotIds = [] }) => {
      hotspotIds.forEach((id) => {
        set.add(id);
      });
    });
  return Array.from(set);
}
